import { photos, logos, icequbeProducts } from "../../images/index";

export const about = {
  imgBg: photos.splash,
  header: {
    companyName: "WIR WERDEN DIE ZUKUNFT GESTALTEN",
    slogan: "SMARTqube",
    description: "Unser Team ist unser größtes Kapital.",
    greenBtn: "kontakt",
    transparentBtn: "lösungen",
    greenBtnLinkTo: "contact",
    transparentBtnLinkTo: "climatecontrol",
  },
  companyDescription: [
    {
      header: "UNSERE WURZELN",
      section1:
        "SMARTqube ist ein polnisches Unternehmen, das eng mit ICEqube in Pennsylvania, USA, verbunden ist. Wir bringen die besten Eigenschaften beider Herkünfte zusammen und kombinieren die Zuverlässigkeit unserer Lösungen mit einem flexiblen und innovativen Ansatz. Unsere Synergie schafft eine einzigartige Basis und garantiert höchste Qualität und Spitzeninnovation in allem, was wir tun.",
      section2:
        "Willkommen zu nahtloser Genialität von Präzision und Unternehmertum.",
      img: photos.iceCube,
    },
    {
      header: "UNSERE LEUTE",
      section1:
        "Bei SMARTqube trägt jeder von uns jahrelange Erfahrung aus verschiedenen internationalen Organisationen bei, die in einer gemeinsamen Vision und grenzenloser Leidenschaft für Kreativität gipfelt. Unsere kollektive Reise übersteigt die bloße Expertise und umfasst einen Reichtum an Ideen und unerschütterlichem Engagement.",
      section2:
        "Unsere Bemühungen und Fachkenntnisse haben Auswirkungen auf verschiedene Bereiche gehabt, einschließlich Kraftwerke im Nahen Osten, Stahlwerke in Osteuropa und Plattformen in der Nordsee. Der Kern unserer gemeinsamen Erfahrung dreht sich um Prozessanalyse und Messungen (Instrumentierung).",
      img: logos.logoTm,
    },
  ],
  team: {
    slogan: "ENTDECKEN SIE UNSERE MANNSCHAFT",
    title: "UNSERE MENSCHEN SIND UNSER GRÖSSTES KAPITAL",
    text: "Bei SMARTqube glauben wir, dass der Erfolg unseres Unternehmens in den Menschen liegt, die es antreiben. Unsere Crew besteht nicht nur aus Fachleuten in ihren Bereichen, sondern vor allem aus Menschen, die vor Leidenschaft, Kreativität und Engagement strotzen",
    galery:
      "https://images.pexels.com/photos/5676679/pexels-photo-5676679.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
  },
  offers: {
    title: "Entdecken Sie Unsere Dienstleistungen",
    carts: [
      {
        id: 1,
        title: "EXKLUSIVER VERTRIEBSHÄNDLER FÜR ICEQUBE PRODUKTE",
        content:
          "Wir sind die alleinigen Vertriebshändler für ICEqube Produkte in Europa. Unser lokales Lager in Verbindung mit einem speziellen Logistikbüro arbeitet zusammen, um die Zugänglichkeit der ICEqube Produkte zu erhöhen. Erleben Sie schnellere Lieferzeiten und reduzierte Versandkosten für Ihre Bequemlichkeit!",
        img: icequbeProducts.evSeries,
      },
      {
        id: 2,
        title:
          "AUSSCHREIBUNGSUNTERSTÜTZUNG, STANDORTBEWERTUNGEN UND MACHBARKEITSSTUDIEN",
        content:
          "Unser Kundensupportteam, zusammen mit einem Netzwerk von Vertriebspartnern in ganz Europa, steht bereit, Sie mit ihrem besten Wissen bei der Auswahl der richtigen Lösungen zu unterstützen, um selbst die anspruchsvollsten Anwendungen zu erfüllen. Bei SMARTqube ist Ihre Zufriedenheit und Ihr Erfolg unsere Priorität!",
        img: photos.support,
      },
      {
        id: 3,
        title: "DESIGN UND INTEGRATION",
        content:
          "Im Mittelpunkt unseres Rufs steht unser Sektor für Integrierte Lösungen. Unsere gut ausgestattete Werkstatt und unser engagiertes Projektengineering-Team verwirklichen Ihre Visionen und übernehmen komplette schlüsselfertige Projekte. Es ist mehr als nur eine Baustelle - von der ersten Idee bis zur endgültigen Inbetriebnahme und dem Start Ihres Systems, Ihr Projekt ist in sicheren Händen.",
        img: photos.tenderSupport,
      },
      {
        id: 4,
        title: "ERFAHRENES SERVICE- & ENGINEERING-TEAM",
        content:
          "Immer wenn eine Inbetriebnahme vor Ort, Wartung, Reparaturen oder Änderungen erforderlich sind, können Sie sich auf unsere freundliche Servicegruppe verlassen, um selbst die kniffligsten technischen Probleme mit einem Lächeln zu bewältigen! Für uns ist nichts unmöglich!",
        img: photos.fieldServices,
      },
      {
        id: 5,
        title: "VERPACKUNG UND LOGISTIK",
        content:
          "Mit einer zentralen Lage in Breslau, Polen, erstrecken sich unsere effektiven Operationen über das gesamte europäische Gebiet, aber nicht nur darauf beschränkt!",
        img: photos.logistic,
      },
    ],
    cartsUSA: [
      {
        id: 1,
        title: "EXKLUSIVER VERTRIEBSHÄNDLER FÜR ICEQUBE PRODUKTE",
        content:
          "Wir sind die alleinigen Vertriebshändler für ICEqube Produkte in Europa. Unser lokales Lager in Verbindung mit einem speziellen Logistikbüro arbeitet zusammen, um die Zugänglichkeit der ICEqube Produkte zu erhöhen. Erleben Sie schnellere Lieferzeiten und reduzierte Versandkosten für Ihre Bequemlichkeit!",
        img: icequbeProducts.evSeries,
      },
      {
        id: 2,
        title:
          "AUSSCHREIBUNGSUNTERSTÜTZUNG, STANDORTBEWERTUNGEN UND MACHBARKEITSSTUDIEN",
        content:
          "Unser Kundensupportteam, zusammen mit einem Netzwerk von Vertriebspartnern in ganz Europa, steht bereit, Sie mit ihrem besten Wissen bei der Auswahl der richtigen Lösungen zu unterstützen, um selbst die anspruchsvollsten Anwendungen zu erfüllen. Bei SMARTqube ist Ihre Zufriedenheit und Ihr Erfolg unsere Priorität!",
        img: photos.support,
      },
      {
        id: 3,
        title: "DESIGN UND INTEGRATION",
        content:
          "Im Mittelpunkt unseres Rufs steht unser Sektor für Integrierte Lösungen. Unsere gut ausgestattete Werkstatt und unser engagiertes Projektengineering-Team verwirklichen Ihre Visionen und übernehmen komplette schlüsselfertige Projekte. Es ist mehr als nur eine Baustelle - von der ersten Idee bis zur endgültigen Inbetriebnahme und dem Start Ihres Systems, Ihr Projekt ist in sicheren Händen.",
        img: photos.tenderSupport,
      },
      {
        id: 4,
        title: "ERFAHRENES SERVICE- & ENGINEERING-TEAM",
        content:
          "Immer wenn eine Inbetriebnahme vor Ort, Wartung, Reparaturen oder Änderungen erforderlich sind, können Sie sich auf unsere freundliche Servicegruppe verlassen, um selbst die kniffligsten technischen Probleme mit einem Lächeln zu bewältigen! Für uns ist nichts unmöglich!",
        img: photos.fieldServices,
      },
      {
        id: 5,
        title: "VERPACKUNG UND LOGISTIK",
        content:
          "Mit einem zentralen Standort in Greensburg, PA, erstrecken sich unsere effektiven Operationen über den gesamten amerikanischen Kontinent, aber sie sind nicht darauf beschränkt!",
        img: photos.logistic,
      },
    ],
  },
  callToaction: {
    titile: "Zögern Sie nicht, uns jederzeit zu kontaktieren.",
    subtitle: "Haben Sie Fragen?",
    button: ["Kontaktieren Sie uns", "contact"],
  },

  location: {
    src: photos.headquarters,
    title: "Hauptsitz in Breslau",
    subtitle: "BESUCHEN SIE UNSER SMARTqube TEAM",
    description: `Unsere Smartqube-Einrichtung ist strategisch günstig in Breslau, Polen, direkt neben der Autobahn A8 gelegen, was einen einfachen Zugang für alle Arten von Fracht, einschließlich Übergrößen-Transport, ermöglicht. Gäste können den internationalen Flughafen Breslau in nur 5 Minuten erreichen. Unser Hauptsitz umfasst ein Lager, eine zollfreie Zone für eingehende Ausrüstung aus den Vereinigten Staaten, eine Werkstatt und Büros.`,
  },
  locationUSA: {
    src: photos.sartQubeHeadquarters,
    title: "Hauptsitz in Greensburg, PA",
    subtitle: "BESUCHEN SIE UNSER SMARTqube TEAM",
    description:
      "Unsere Smartqube-Einrichtung in Greensburg, PA, befindet sich idealerweise an der 141 Wilson Avenue, nahe wichtiger Straßen, was eine effiziente Logistik und Transport ermöglicht. In einer dynamisch entwickelnden Region gelegen, garantieren wir Zugang zu einem Team von Fachleuten und einer umfangreichen Infrastruktur. Unser Lager zusammen mit den Büros bietet eine sichere und effektive Umgebung für unsere Operationen und ermöglicht es uns, den wachsenden geschäftlichen Anforderungen gerecht zu werden.",
  },
};
